import React from 'react';
import cn from 'classname';

import './main.less';

const Switch = props => {

	const { periodSwitch, togglePeriodSwitch }  = props;

	return (
		<div className="guarant-approve-forecast-date-switch-container">
			<button
				className={cn({
					'ui-btn': true,
					'guarant-approve-forecast-date-switch': true,
					'guarant-approve-forecast-date-switch-active': !periodSwitch || periodSwitch === 'week'
				})}
				onClick={togglePeriodSwitch.bind(null, null)}
			>
				Week
			</button>
			<button
				className={cn({
					'ui-btn': true,
					'guarant-approve-forecast-date-switch': true,
					'guarant-approve-forecast-date-switch-active': periodSwitch === 'month'
				})}
				onClick={togglePeriodSwitch.bind(null, 'month')}
			>
				Month
			</button>
		</div>
	);
};

export default Switch;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/garant-forecast/components/switch/main.js